import React from "react";
import "../../assets/css/style.css";

const SupportingVision = () => {
  return (
    <div className="container mt-50">
      <div className="section-title text-center tg-heading-subheading animation-style2">
        <span className="sub-title tg-element-title"></span>
        <h2 className="title tg-element-title">Partnered for Vision</h2>
        <div class="row">
          <div class="col-12 lg-padding">
            <div class="banner-image"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportingVision;
